// https://rangle.io/blog/simplifying-controlled-inputs-with-hooks/
import { useState } from 'react';

interface IRequiredInput {
  value: string;
  setValue: (value: string) => void;
  valid: boolean;
  setValid: (valid: boolean) => void;
  reset: () => void;
  bind: {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  };
  isNotEmpty: (val: string) => boolean;
}

const useRequiredInput = (initialValue: string): IRequiredInput => {
  const isNotEmpty = (val: string): boolean => {
    if (val.length > 0) {
      return true;
    }
    return false;
  };

  const [value, setValue] = useState<string>(initialValue);
  const [valid, setValid] = useState<boolean>(isNotEmpty(initialValue));

  const reset = (): void => {
    setValue(initialValue);
    setValid(isNotEmpty(initialValue));
  };

  const bind = {
    value,
    onChange: (event: React.ChangeEvent<HTMLInputElement>): void => {
      setValue(event.target.value);
      setValid(isNotEmpty(event.target.value));
    },
  };

  return {
    value,
    setValue,
    valid,
    setValid,
    reset,
    bind,
    isNotEmpty,
  };
};

export default useRequiredInput;
